import React from 'react';

const ACTIONS = [
  { id: 'copy', label: 'Copy' },
  { id: 'insert', label: 'Insert into Compose', primary: true },
  { id: 'regenerate', label: 'Regenerate' },
  { id: 'improve', label: 'Improve' },
  { id: 'rewrite', label: 'Rewrite' },
  { id: 'translate', label: 'Translate' },
  { id: 'shorten', label: 'Shorten' },
  { id: 'expand', label: 'Expand' },
  { id: 'change_tone', label: 'Change Tone' },
];

export default function AIComposeToolbar({
  disabled = false,
  onAction,
  showInsert = true,
}) {
  return (
    <div className="aic-toolbar">
      {ACTIONS.filter((a) => showInsert || a.id !== 'insert').map((action) => (
        <button
          key={action.id}
          type="button"
          className={`aic-btn${action.primary ? ' aic-btn-primary' : ''}`}
          disabled={disabled}
          onClick={() => onAction?.(action.id)}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}
